// extracted by mini-css-extract-plugin
export var typingIndicator = "_q3-0";